import moment from 'moment'

const yearsOptions = Array.from({ length: 10 }, (_, i) => {
  const year = moment().subtract(i, 'years').format('YYYY')
  return {
    name: Number(year),
    value: Number(year)
  }
})

export default yearsOptions
